/**
 * Detects if the user is on a Mac
 */
export const isMac = (): boolean => {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};

/**
 * Returns the appropriate modifier key name based on the platform
 */
export const getModifierKey = (): string => {
  return isMac() ? 'Cmd' : 'Ctrl';
};

/**
 * Returns the appropriate modifier key symbol based on the platform
 */
export const getModifierKeySymbol = (): string => {
  return isMac() ? '⌘' : 'Ctrl';
};
